module.exports = __webpack_public_path__ + "static/media/workoutLegs.4b6217c6.png";